import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"checkmark\"><path d=\"M470 51C291 154 195 259 163 304L38 240c-3 0-6-3-9-3-10 0-16 3-23 13-9 19-3 38 0 44 4 4 7 10 10 13 48 29 109 112 128 141 3 3 3 6 6 6 10 7 23 10 32 10 20 0 32-10 36-10 3-3 6-9 9-16 45-179 269-323 272-323 3-3 7-3 7-9 12-20 6-39-4-52-6-3-12-6-19-6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/checkmark.svg
// module id = 188
// module chunks = 0